const Images = {

    /**
     * @NetWork Icons
     */

    /**
     * @TabBar Icons
     */

    /**
     * @Common [通用]
     */
    icon_warn: require('./newImg/warn.png'),

    /**
     * @Images
     */

}

export default Images;